import { sendGTMEvent } from '@next/third-parties/google';
import { Effect, Option, Schema } from 'effect';

import { getGoogleTagManagerId } from '@vs-shop/engine/config/google';
import { GtmSendError } from '@vs-shop/engine/data/error/gtm';
import type { GtmEvent } from '@vs-shop/schemas/gtm/all';
import { GtmEventSchema } from '@vs-shop/schemas/gtm/all';

export const sendGtmEvent = (event: GtmEvent, emptyEcommerce = false) =>
  Effect.gen(function* () {
    const gtmIdOption = yield* getGoogleTagManagerId;

    if (Option.isNone(gtmIdOption)) {
      const encodedEvent = yield* Schema.encodeEffect(GtmEventSchema)(event);
      yield* Effect.logDebug('🔍 GTM event not sent (GTM ID not configured)', encodedEvent);
      return;
    }

    if (emptyEcommerce) {
      yield* Effect.try({
        try: () => {
          sendGTMEvent({ ecommerce: null });
        },
        catch: (error) => new GtmSendError({ event, cause: error }),
      });
    }

    yield* Effect.try({
      try: () => {
        sendGTMEvent(event);
      },
      catch: (error) => new GtmSendError({ event, cause: error }),
    });
  });
